const LETTERS = ['L', 'E', 'X', 'I', 'R', 'A'];

export default function LogoTiles({ size = 'hero' }) {
  if (size === 'nav') {
    return (
      <div className="navbar-logo">
        {LETTERS.map((l, i) => <span key={i}>{l}</span>)}
      </div>
    );
  }
  return (
    <div className="hero-logo">
      {LETTERS.map((l, i) => <span key={i} className="letter-tile">{l}</span>)}
    </div>
  );
}
